/**
 * [page 主要路由]
 * Created by kahn on 2020/09/14.
 */

export default [
  {
    path: '/',
    redirect: { name: 'Home' }
  },
  {
    path: '/home',
    component: () => import('@/page/home/Home.vue'),
    name: 'Home',
    meta: { title: '首页' }
  },
  {
    path: '/myPlan',
    component: () => import('@/page/home/MyPlan.vue'),
    name: 'myPlan',
    meta: { title: '我的计划' }
  },
  {
    path: '/firstStep',
    component: () => import('@/page/home/FirstStep.vue'),
    name: 'FirstStep',
    meta: { title: '第一步' }
  },
  {
    path: '/secondStep',
    component: () => import('@/page/home/SecondStep.vue'),
    name: 'SecondStep',
    meta: { title: '第二步' }
  },
  {
    path: '/thirdStep',
    component: () => import('@/page/home/ThirdStep.vue'),
    name: 'ThirdStep',
    meta: { title: '第三步' }
  }, {
    path: '/login',
    component: () => import('@/page/home/Login.vue'),
    name: 'Login',
    meta: { title: '第三步' }
  },
]



// WEBPACK FOOTER //
// ./src/router/routers.js